import { Component, Vue } from 'vue-property-decorator'

@Component
export class Navigator extends Vue {
  navigator = {
    isMSIE: navigator.userAgent.match(/trident\//i),
    isChrome: navigator.vendor.match(/google/i),
    isOpera: navigator.userAgent.match(/opera\//i),
    isSafari: navigator.vendor.match(/apple/i),
    isFirefox: navigator.userAgent.match(/firefox\//i),
    isEdge: navigator.userAgent.match(/edge\//i),
  }
}
